import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vh-100 w-100 d-flex justify-content-center align-items-center" }

import {useLayoutsStore} from "@/composables/layouts";

export default /*@__PURE__*/_defineComponent({
  __name: 'UnauthorizedView',
  setup(__props) {

const layoutStore = useLayoutsStore();
layoutStore.changeLayout('empty')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("span", { class: "h4 text-center" }, "У вас нет доступа для работы в приложении.", -1)
  ])))
}
}

})